import { render } from "./TheAlarmTypesDetails.vue?vue&type=template&id=6c513de6"
import script from "./TheAlarmTypesDetails.vue?vue&type=script&lang=js"
export * from "./TheAlarmTypesDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__